import React from 'react';

const AccessDeniedPage: React.FC = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '2rem',
      textAlign: 'center'
    }}>
      <h1 style={{ fontSize: '6rem', fontWeight: '700', color: '#EF4444', margin: 0 }}>403</h1>
      <h2 style={{ fontSize: '2rem', fontWeight: '600', color: '#111827', marginTop: '1rem' }}>Access Denied</h2>
      <p style={{ color: '#6B7280', marginTop: '1rem', maxWidth: '500px' }}>
        You don't have permission to access this page. Please contact your administrator if you believe this is an error.
      </p>
      <a 
        href="/" 
        style={{
          marginTop: '2rem',
          padding: '0.75rem 2rem',
          backgroundColor: '#61A1D4',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '8px',
          fontWeight: '600'
        }}
      >
        Go Home
      </a>
    </div>
  );
};

export default AccessDeniedPage;
